import { render, staticRenderFns } from "./BottonmMenu2.vue?vue&type=template&id=2a37dc0a"
import script from "./BottonmMenu2.vue?vue&type=script&lang=js"
export * from "./BottonmMenu2.vue?vue&type=script&lang=js"
import style0 from "./BottonmMenu2.vue?vue&type=style&index=0&id=2a37dc0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports